import { Link, useLocation } from "react-router-dom";
import LogoMark from "@/components/site/LogoMark";
import CompassO from "@/components/site/CompassO";

export default function Header() {
  const { pathname } = useLocation();
  const onLanding = pathname === "/";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[color:var(--navy-950)]/70 border-b border-[color:var(--border-subtle)]"
    >
      <div className="px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
        <Link to="/" data-testid="header-home-link" className="flex items-center gap-3">
          <LogoMark size={44} />
          <div className="leading-tight">
            <div
              className="font-display font-bold uppercase tracking-tight text-base md:text-lg flex items-center"
              data-testid="header-wordmark"
            >
              <span>The Way&nbsp;F</span>
              <CompassO size={14} />
              <span>rward</span>
            </div>
            <div className="eyebrow text-[10px]">.solutions</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-display uppercase tracking-[0.18em] text-sm">
          {onLanding ? (
            <>
              <a data-testid="nav-about" href="#about" className="hover:text-[color:var(--gold-500)] transition-colors">About</a>
              <a data-testid="nav-book" href="#book" className="hover:text-[color:var(--gold-500)] transition-colors">The Book</a>
              <a data-testid="nav-signup" href="#signup" className="hover:text-[color:var(--gold-500)] transition-colors">Sign Up</a>
              <Link data-testid="nav-card" to="/business-card" className="hover:text-[color:var(--gold-500)] transition-colors">Card</Link>
            </>
          ) : (
            <Link data-testid="nav-home" to="/" className="hover:text-[color:var(--gold-500)] transition-colors">Home</Link>
          )}
        </nav>

        <a
          data-testid="header-cta-apply"
          href={onLanding ? "#signup" : "/#signup"}
          className="btn-gold text-xs md:text-sm"
        >
          Apply Now
        </a>
      </div>
    </header>
  );
}
